import Styles from './RestoreGroupModal.scss';
import Chooser from 'views/components/chooser/Chooser.svelte'
import RestoreGroupStudents from './parts/RestoreGroupStudents'
import TimeUtil from 'util/TimeUtil'

export default class RestoreGroupModal extends BaseView {

    get tagName() {
        return 'div'
    }

    initialize() {

        // Add chooser with option for every archived group in the collection
        this.chooser = this.addSvelteChildView(this.$el, Chooser, {
            emptyStateMessage: window.i18n.gettext('You do not have any removed groups. Thus restoring a group is not possible.'),
            list: this.collection.map((archivedGroup) => {

                // Only display level and grade when level is globally available.
                // Fix for: S133 in Sentry.
                const level = Backbone.Collection.levels.get(archivedGroup.get('level_id'))
                const metaLabel = level ?
                    Backbone.Collection.levels.get(archivedGroup.get('level_id')).get('name') + ' ' + archivedGroup.get('grade') :
                    ''

                return {
                    id: archivedGroup.id,
                    label: archivedGroup.get('name'),
                    subText: metaLabel,
                    rightAlignedText: `${window.i18n.gettext('Removed on')} ${TimeUtil.getAbsoluteDate(archivedGroup.get('archived_on'))}`
                }
            })
        })

    }

    addButtons() {
        if (this.collection.length === 0) {
            Backbone.View.Components.modal.addButtons({
                [window.i18n.gettext('Close')]: {
                    callback: Backbone.View.Components.modal.close,
                },
            }, true)
            return
        }

        Backbone.View.Components.modal.addButtons({
            [window.i18n.gettext('Cancel')]: {
                callback: Backbone.View.Components.modal.close,
                theme: 'secondary',
            },
            [window.i18n.gettext('Restore')]: {
                callback: () => {
                    const selection = this.chooser.getSelection()
                    if (!selection) {
                        Backbone.View.layout.openStatus(
                            window.i18n.gettext('Select a group')
                        )
                        return
                    }

                    // If selected group does not have any students it anyway, skip the next modal part where the
                    // user gets asked if they want to restore the group with or without its students. Instead do
                    // the request to restore the selected group directly.
                    const selectedGroup = this.collection.get(selection.id)
                    if (selectedGroup.get('students') === 0) {
                        RestoreGroupStudents.unarchiveGroup(selectedGroup.toJSON(), false, () => {
                            location.reload()
                        })
                        return
                    }

                    // Ask the user if they want to restore the group with or without its students.
                    Backbone.View.Components.modal.add(RestoreGroupStudents, {
                        title: window.i18n.gettext('With or without students?'),
                        group: selectedGroup.toJSON(),
                        studentCount: selectedGroup.get('students'),
                        callback: () => {
                            location.reload()
                        },
                    })
                },
            }
        }, true)
    }

}
